import React, { useEffect } from 'react'
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import { useParams, useLocation } from 'react-router' 
import ViewClinicDetails from '../../containers/clinics/ViewClinicDetails';
import ClinicsProvider from '../../store/clinics/clinicsProvider';
import AddClinic from '../../containers/clinics/AddClinic';
import UsersProvider from '../../store/users/usersProvider';

function ClinicDetails() {
  const { id } = useParams(); 
  const location = useLocation();

  const { appState: { user }} = useApp();
  const [pageTitle, setPageTitle] = React.useState('');

  const addClinic = location.pathname.includes('/add');

  useEffect(() => {
    if (id) setPageTitle('Clinic details');
    if (addClinic) setPageTitle('Add clinic');
  }, [])

  if (!user) return '';
  if (!user._id) return '';

  return (
    <ClinicsProvider>
      <UsersProvider>
      <PageWrapper navbar title={pageTitle}>
        {id && <ViewClinicDetails clinicId={id}/>}
        {addClinic && <AddClinic />}
      </PageWrapper>
      </UsersProvider>
    </ClinicsProvider>
  )
}

export default ClinicDetails;